import { Link } from "react-router-dom";
import { Lightning } from "@phosphor-icons/react";

/**
 * Site-wide footer shown on Landing and all legal/static pages.
 * Keep this lean and identical everywhere for visual consistency.
 */
export default function SiteFooter() {
  return (
    <footer className="bg-white border-t border-gray-100 mt-16">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-10 grid gap-8 sm:gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Link to="/" className="inline-flex items-center gap-2" data-testid="footer-logo">
            <span className="w-9 h-9 rounded-xl bg-[#F8CB46] flex items-center justify-center">
              <Lightning weight="fill" size={18} />
            </span>
            <span className="font-heading font-black text-lg tracking-tight">QuickDukaan</span>
          </Link>
          <p className="text-sm text-gray-600 mt-3 max-w-sm leading-relaxed">
            Hyperlocal quick-commerce for India. Every local store gets its own Blinkit-style online shop in minutes.
          </p>
        </div>

        <div>
          <div className="font-heading font-black text-sm uppercase tracking-widest text-gray-500 mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/contact-us" className="text-gray-700 hover:text-[#15803D] transition" data-testid="footer-contact">Contact us</Link></li>
            <li><Link to="/QDplatform" className="text-gray-700 hover:text-[#15803D] transition">About platform</Link></li>
            <li><Link to="/seller/login" className="text-gray-700 hover:text-[#15803D] transition">Become a seller</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-heading font-black text-sm uppercase tracking-widest text-gray-500 mb-3">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy-policy" className="text-gray-700 hover:text-[#15803D] transition" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms-and-conditions" className="text-gray-700 hover:text-[#15803D] transition" data-testid="footer-terms">Terms & Conditions</Link></li>
            <li><Link to="/refund-cancellation-policy" className="text-gray-700 hover:text-[#15803D] transition" data-testid="footer-refund">Refund & Cancellation</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-gray-100">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="text-xs text-gray-500">© 2026 QuickDukaan. Made for Indian retailers.</div>
          <div className="text-xs text-gray-500">
            <a href="mailto:support@quickdukaan.in" className="hover:text-[#15803D] transition">
              support@quickdukaan.in
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
